import { Table } from 'react-bootstrap';
import styled from 'styled-components';

export const ExpertAnalysisWrapper = styled.div`
    // body {
    //     color: #000;
    //     font-family: 'Roboto Condensed', sans-serif;
    //     font-size: 16px;
    //     line-height: 1.25;
    //     margin: 0;
    //     overflow-x: hidden;
    //     padding: 0;
    // }
    
    
    /* TYPOGRAPHY --------------------------------- */
    h1 {
        color: var(--red);
        font-weight: 700;
    }
    
    h2 {
        color: var(--dk-blue);
        font-weight: 700;
    }
    
    a {
        color: var(--blue);
    }
    
    a:hover, a:focus {
        color: var(--red);
        text-decoration: none;
    }
    
    // .btn {
    //     background-color: var(--blue);
    //     border: 0;
    //     color: #FFF;
    //     font-size: 1em;
    //     position: relative;
    // }
    
    .btn.green {
        background-color: var(--green)
    }
    
    .btn:hover, .btn:focus, .btn.green:hover, .btn.green:focus {
        background-color: var(--yellow);
        color: #000;
    }
    
    .tag {
        border-radius: .25em;
        display: inline-block;
        font-weight: 400;
        line-height: 1.6;
        margin-inline: 0 .25em;
        padding: .4375em 1em;
    }
    
    .tag.green {
        background-color: var(--green);
    }
    
    .tag.orange {
        background-color: var(--orange);
    }
    
    .tag.yellow {
        background-color: var(--yellow);
    }
    
    /* TRANSITIONS --------------------------------- */
    a, a::before, a::after, .btn {
        transition: all .3s ease;
    }
    
    /* TABLES --------------------------------- */
    table>thead>tr>th,
    table>tbody>tr:not(:last-of-type)>th,
    table>tbody>tr:not(:last-of-type)>td {
        border-bottom: 1px solid #B9CEE6;
    }
    
    table>tbody>tr:nth-child(odd) {
        background: rgba(59,118,181,.2);
    }
    
    /* RIBBON 1 --------------------------------- */
    #ribbon-1.bordered {
        border-top: .5em solid var(--red);
    }
    
    /* RIBBON  4 --------------------------------- */
    #ribbon-2 {
        position: relative;
    }
    
    #ribbon-2::before {
        background: var(--blue);
        content: '';
        height: 100%;
        left: 0;
        opacity: .2;
        position: absolute;
        top: 0;
        width: 100%;
    }
    
    #ribbon-2 .tag {
        margin-block: .25em;
    }
    
    /* MEDIA QUERIES --------------------------------- */
    
    /* Min Width ----- */
    @media (min-width: 768px) {
        h1 {
        font-size: 1.875em;
        }
    
        h2 {
        font-size: 1.5em;
        }
    }
    
    @media (min-width: 1200px) {
        #ribbon-1 .col-buttons {
        width: 20%;
        }
    
        #ribbon-1 .col-table {
        width: 30%;
        }
    
        .container {
        width: 1200px;
        }
    }
    
    /* Max Width ----- */
    @media (max-width: 1199px) {
        .container {
        width: 100%;
        }
    }
    
    @media (max-width: 767px) {
        h1 {
            font-size: 1.5em;
        }
    
        h2 {
            font-size: 1.3125em;
        }
    }
    
    /* ------------------------------------------------------------ */
    
    /* Below are some Bootstrap 5 utility classes used in the markup that will make it easier to convert these pages to BS5 */
    /* These styles can be removed from this stylesheet once migrated to BS5 */
    .d-block { display: block; }
    .d-flex { display: flex; }
    .d-inline-block { display: inline-block; }
    .float-none { float: none; }
    
    .mx-0{margin-right:0!important;margin-left:0!important}.mx-1{margin-right:.25rem!important;margin-left:.25rem!important}.mx-2{margin-right:.5rem!important;margin-left:.5rem!important}.mx-3{margin-right:1rem!important;margin-left:1rem!important}.mx-4{margin-right:1.5rem!important;margin-left:1.5rem!important}.mx-5{margin-right:3rem!important;margin-left:3rem!important}.mx-auto{margin-right:auto!important;margin-left:auto!important}.my-0{margin-top:0!important;margin-bottom:0!important}.my-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-3{margin-top:1rem!important;margin-bottom:1rem!important}.my-4{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.my-5{margin-top:3rem!important;margin-bottom:3rem!important}.my-auto{margin-top:auto!important;margin-bottom:auto!important}.m-0{margin:0!important}.m-1{margin:.25rem!important}.m-2{margin:.5rem!important}.m-3{margin:1rem!important}.m-4{margin:1.5rem!important}.m-5{margin:3rem!important}.mt-0{margin-top:0!important}.mt-1{margin-top:0.25rem!important}.mt-2{margin-top:0.5rem!important}.mt-3{margin-top:1rem!important}.mt-4{margin-top:1.5rem!important}.mt-5{margin-top:3rem!important}.mt-auto{margin-top:auto!important}.me-0{margin-right:0!important}.me-1{margin-right:0.25rem!important}.me-2{margin-right:0.5rem!important}.me-3{margin-right:1rem!important}.me-4{margin-right:1.5rem!important}.me-5{margin-right:3rem!important}.me-auto{margin-right:auto!important}.mb-0{margin-bottom:0!important}.mb-1{margin-bottom:0.25rem!important}.mb-2{margin-bottom:0.5rem!important}.mb-3{margin-bottom:1rem!important}.mb-4{margin-bottom:1.5rem!important}.mb-5{margin-bottom:3rem!important}.mb-auto{margin-bottom:auto!important}.ms-0{margin-left:0!important}.ms-1{margin-left:0.25rem!important}.ms-2{margin-left:0.5rem!important}.ms-3{margin-left:1rem!important}.ms-4{margin-left:1.5rem!important}.ms-5{margin-left:3rem!important}.ms-auto{margin-left:auto!important}.mx-auto{margin-right:auto!important;margin-left:auto!important}
    
    .px-0{padding-right:0!important;padding-left:0!important}.px-1{padding-right:.25rem!important;padding-left:.25rem!important}.px-2{padding-right:.5rem!important;padding-left:.5rem!important}.px-3{padding-right:1rem!important;padding-left:1rem!important}.px-4{padding-right:1.5rem!important;padding-left:1.5rem!important}.px-5{padding-right:3rem!important;padding-left:3rem!important}.py-0{padding-top:0!important;padding-bottom:0!important}.py-1{padding-top:.25rem!important;padding-bottom:.25rem!important}.py-2{padding-top:.5rem!important;padding-bottom:.5rem!important}.py-3{padding-top:1rem!important;padding-bottom:1rem!important}.py-4{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.py-5{padding-top:3rem!important;padding-bottom:3rem!important}.p-0{padding:0!important}.p-1{padding:.25rem!important}.p-2{padding:.5rem!important}.p-3{padding:1rem!important}.p-4{padding:1.5rem!important}.p-5{padding:3rem!important}.pt-0{padding-top:0!important}.pt-1{padding-top:0.25rem!important}.pt-2{padding-top:0.5rem!important}.pt-3{padding-top:1rem!important}.pt-4{padding-top:1.5rem!important}.pt-5{padding-top:3rem!important}.pe-0{padding-right:0!important}.pe-1{padding-right:0.25rem!important}.pe-2{padding-right:0.5rem!important}.pe-3{padding-right:1rem!important}.pe-4{padding-right:1.5rem!important}.pe-5{padding-right:3rem!important}.pb-0{padding-bottom:0!important}.pb-1{padding-bottom:0.25rem!important}.pb-2{padding-bottom:0.5rem!important}.pb-3{padding-bottom:1rem!important}.pb-4{padding-bottom:1.5rem!important}.pb-5{padding-bottom:3rem!important}.ps-0{padding-left:0!important}.ps-1{padding-left:0.25rem!important}.ps-2{padding-left:0.5rem!important}.ps-3{padding-left:1rem!important}.ps-4{padding-left:1.5rem!important}.ps-5{padding-left:3rem!important}
  
`;

export const TableWrapper = styled(Table)`
    & > thead > tr > th {
        text-align: center;
        cursor: default;
        background-color: lightgray;
    }

    & > tbody > tr > td {
        vertical-align: middle;
        text-align: center;
    }

    margin-bottom: 0px;
`;

export const GridWrapper = styled.div`
    width: 99.9%;
    height: 66vh;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        // line-height: 33px;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #ddd;
        color: #123;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    div.ag-root .ag-cell-focus {
        user-select: text !important;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #ccc;
    }

    .list-cell > .ag-cell-wrapper {
        display: flex;
        justify-content: center;
    }

    .list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #B7B7B7;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        border-color: #eee;
        border-width: 0px 0px 0px 1px;
        border-style: solid;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }

    @media screen and (width < 1920px) {
        font-size: 11px;
    }
`;
